import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'ui-components/Button'
import { Buttons, Container, Content } from './styles'

export default function Form(props) {
  const {
    children,
    onSubmit,
    onCancel,
    onSave,
    saving,
  } = props

  const handleSubmit = (evt) => {
    evt.preventDefault()
    onSubmit()
  }

  return (
    <Container>
      <Content>
        <form onSubmit={handleSubmit}>
          {children}
          <Buttons>
            <Button
              onClick={onCancel}
              color="default"
              variant="contained"
              disabled={saving}
            >
              Cancelar
            </Button>
            <Button
              onClick={onSave}
              color="primary"
              variant="contained"
              disabled={saving}
              loading={saving}
            >
              Salvar
            </Button>
          </Buttons>
        </form>
      </Content>
    </Container>
  )
}

Form.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array,
    PropTypes.node,
  ]).isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  saving: PropTypes.bool,
}

Form.defaultProps = {
  onSubmit: () => {},
  saving: false,
}
